module.exports = __webpack_public_path__ + "static/Finance3-3e149012ecf1fcc0a6dd3461a1ce36e7.png";